import { State } from '../../../types';
import { Waiver } from '../../../../types/waiver';

const selectRoot = (state: State) =>
  state.components.waivers.workItem.waiverToChangeAssociation;

export const selectWaiverToChangeAssociation = (state: State): Waiver | null =>
  selectRoot(state).waiver ?? null;
